import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Type } from 'class-transformer';
import { InteractivePropertyInfo } from '../../../components/common/datasourceselectioncontol/datasource.selection.control';
import { RequestOptionsColumn, RequestOptionsControl } from '../../../components/common/requestoptions/request.options.control';
import { RequestOptions } from '../../../models/rest/requestoptions';
import { DataModelService } from '../../../services/datamodel.service';
import { ContainerFieldEditDialog } from '../../../settings/datamodel/dialogs/container.field.edit.dialog';
import { DefaultValueSettings } from './default.definition.control';

@Component({
    selector: 'container-chooser-control',
    templateUrl: './container.chooser.html'
})
export class ContainerChooser implements AfterViewInit {
    FilterColumns: RequestOptionsColumn[] = [];
    @ViewChild('advanced') filterComponent: RequestOptionsControl;
    RequestOptions = RequestOptions.CleanRequestOptions();
    CanSelect = false;

    //#region Data
    DataValue: AContainerSettingsData;

    @Input()
    get Data() {
        return this.DataValue;
    }
    set Data(val) {
        this.DataValue = val;
        this.DataChange.emit(this.DataValue);
    }

    @Output() DataChange = new EventEmitter<any>();
    //#endregion

    //#region Variables
    VariablesValue = [];

    @Input()
    get Variables() {
        return this.VariablesValue;
    }
    set Variables(val) {
        this.VariablesValue = val;
        this.VariablesChange.emit(this.VariablesValue);
    }

    @Output() VariablesChange = new EventEmitter<any>();
    //#endregion

    //#region ShowFilter
    ShowFilterValue = false;

    @Input()
    get ShowFilter() {
        return this.ShowFilterValue;
    }
    set ShowFilter(val) {
        this.ShowFilterValue = val;
        this.ShowFilterChange.emit(this.ShowFilterValue);
    }

    @Output() ShowFilterChange = new EventEmitter<any>();
    //#endregion

    //#region ShowFilter
    ShowAdvancedFilterValue = false;

    @Input()
    get ShowAdvancedFilter() {
        return this.ShowAdvancedFilterValue;
    }
    set ShowAdvancedFilter(val) {
        this.ShowAdvancedFilterValue = val;
        this.ShowAdvancedFilterChange.emit(this.ShowAdvancedFilterValue);
    }

    @Output() ShowAdvancedFilterChange = new EventEmitter<any>();
    //#endregion

    //#region ShowValues
    ShowValuesValue = false;

    @Input()
    get ShowValues() {
        return this.ShowValuesValue;
    }
    set ShowValues(val) {
        this.ShowValuesValue = val;
        this.ShowValuesChange.emit(this.ShowValuesValue);
    }

    @Output() ShowValuesChange = new EventEmitter<any>();
    //#endregion

    //#region DBUsages
    DBUsagesValue = [];

    @Input()
    get DBUsages() {
        return this.DBUsagesValue;
    }
    set DBUsages(val) {
        this.DBUsagesValue = val;
        this.DBUsagesChange.emit(this.DBUsagesValue);
    }

    @Output() DBUsagesChange = new EventEmitter<any>();
    //#endregion

    //#region FixedDataModels
    FixedDataModelsValue: any;

    @Input()
    get FixedDataModels() {
        return this.FixedDataModelsValue;
    }
    set FixedDataModels(val) {
        this.FixedDataModelsValue = val;
        this.FixedDataModelsChange.emit(this.FixedDataModelsValue);
    }

    @Output() FixedDataModelsChange = new EventEmitter<any>();
    //#endregion

    @Output() TableChanged = new EventEmitter<any>();

    constructor(private dataService: DataModelService, private cdRef: ChangeDetectorRef) {
    }

    onDataChanged() {
        this.FilterColumns = [];
        this.RequestOptions = RequestOptions.CleanRequestOptions();
        this.CanSelect = false;
        if (this.DataValue) {
            this.DataValue.Values = [];
            if (this.DataValue.ContainerTable) {
                this.dataService.GetFilterInfo(this.DataValue.ContainerTable).subscribe(result => {
                    if (result && result.CanFilter) {
                        this.CanSelect = result.CanSelectColumns;
                        this.FilterColumns = result.Columns.map((x: any) => {
                            const valType = ContainerFieldEditDialog.AllTypes.find(y => y.Value == x.DataType);
                            const col = new RequestOptionsColumn();
                            col.Name = x.Name;
                            col.Caption = x.Caption + ' (' + (valType?.Caption ?? x.DataType) + ')';
                            col.Type = x.DataType;
                            col.CanFilter = result.CanFilter;
                            col.CanSelect = result.CanSelectColumns;
                            return col;
                        });
                    } else {
                        this.DataValue.ContainerTable = null;
                    }
                    this.cdRef.detectChanges();
                });
            } else {
                this.cdRef.detectChanges();
            }
        }
        this.TableChanged.emit();
    }

    onDataChecked() {
        this.FilterColumns = [];
        this.CanSelect = false;
        if (this.DataValue) {
            if (this.DataValue.ContainerTable) {
                this.dataService.GetFilterInfo(this.DataValue.ContainerTable).subscribe(result => {
                    if (result && result.CanFilter) {
                        this.CanSelect = result.CanSelectColumns;
                        this.FilterColumns = result.Columns.map((x: any) => {
                            const valType = ContainerFieldEditDialog.AllTypes.find(y => y.Value == x.DataType);
                            const col = new RequestOptionsColumn();
                            col.Name = x.Name;
                            col.Caption = x.Caption + ' (' + (valType?.Caption ?? x.DataType) + ')';
                            col.Type = x.DataType;
                            col.CanFilter = result.CanFilter;
                            col.CanSelect = result.CanSelectColumns;
                            return col;
                        });
                    } else {
                        this.RequestOptions = RequestOptions.CleanRequestOptions();
                        this.DataValue.Values = [];
                        this.DataValue.ContainerTable = null;
                    }
                    this.cdRef.detectChanges();
                });
            } else {
                this.cdRef.detectChanges();
            }
        }
    }

    ngAfterViewInit(): void {
        if (this.DataValue && this.DataValue.Filter) {
            this.RequestOptions = JSON.parse(JSON.stringify(this.DataValue.Filter));
            this.cdRef.detectChanges();
        }
    }

    CheckActualFilter() {
        if (this.DataValue) {
            if (this.filterComponent) {
                this.filterComponent.applyFilter();
            }
            if (this.RequestOptions &&
                ((this.RequestOptions.Filters && this.RequestOptions.Filters.length > 0) ||
                (this.RequestOptions.Columns && this.RequestOptions.Columns.length > 0) ||
                (this.RequestOptions.Sort && this.RequestOptions.Sort.length > 0) ||
                this.RequestOptions.Distinct)
            ) {
                this.DataValue.Filter = this.RequestOptions;
            } else {
                this.DataValue.Filter = null;
            }
        }
    }

    addValue() {
        if (this.DataValue) {
            if (this.DataValue.Values) {
                this.DataValue.Values.push(new ExecuteValue());
            } else {
                this.DataValue.Values = [new ExecuteValue()];
            }
        }
    }

    preset() {
        if (this.DataValue && this.FilterColumns) {
            if (!this.DataValue.Values) {
                this.DataValue.Values = [];
            }
            this.FilterColumns.forEach(fc => {
                if (!this.DataValue.Values.some(x => x.ColumnName == fc.Name)) {
                    const newVal = new ExecuteValue();
                    newVal.ColumnName = fc.Name;
                    newVal.SetDefault = true;
                    this.DataValue.Values.push(newVal);
                }
            });
        }
    }

    getDefault(val: ExecuteValue) {
        if (val && val.ColumnName) {
            const fc = this.FilterColumns.find(x => x.Name == val.ColumnName);
            if (fc) {
                const settings = this.DataValue?.Defaults ?? new DefaultValueSettings();
                const defObj = settings.getDefaultObject();
                const val = defObj[fc.Type];
                if (val) {
                    return val;
                }
            }
        }
        return '';
    }

    removeValue(i: number) {
        if (this.DataValue && this.DataValue.Values) {
            this.DataValue.Values.splice(i, 1);
        }
    }
}

// @dynamic
export abstract class ABaseContainerSettingsData {
    DataModel: string;
    DataSource: string;
    @Type(() => InteractivePropertyInfo)
    InteractiveProperties: InteractivePropertyInfo[] = [];
    ContainerTable: string;
    ContainerInternalID: string;
    @Type(() => RequestOptions)
    Filter: RequestOptions;
}

// @dynamic
export abstract class AContainerSettingsData extends ABaseContainerSettingsData {
    @Type(() => ExecuteValue)
    Values: ExecuteValue[] = [];
    @Type(() => DefaultValueSettings)
    Defaults: DefaultValueSettings;
}

export class ExecuteValue {
    ColumnName: string;
    Value: string;
    SetDefault = false;
}
